module.exports = __webpack_public_path__ + "static/media/Historial_no_disponibles.94993525.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/Historial_no_disponibles.svg
// module id = 1860
// module chunks = 0